import type { AuditLogEntry, AuditLogFilters, AuditScopeKind, AuditScopeOption } from './types';
import { AUDIT_SCOPE_KINDS } from './types';

const SCOPE_KEY = {
    client: 'clientId',
    location: 'locationId',
    cage: 'cageId',
} as const satisfies Record<AuditScopeKind, keyof AuditLogFilters>;

function optionFrom(entry: AuditLogEntry, kind: AuditScopeKind): AuditScopeOption | null {
    const ref = entry[kind];
    if (ref === null || ref.name === null) return null;
    return {
        kind,
        id: ref.id,
        name: ref.name,
        state: ref.state,
        clientName: kind === 'client' ? null : (entry.client?.name ?? null),
        locationName: kind === 'cage' ? (entry.location?.name ?? null) : null,
    };
}

/**
 * The clients, sites and pens the filters name, as the loaded rows name them now. A click
 * on a path segment or a dialog row comes from a loaded row, so keeping these, as a scope
 * picker pick is kept, leaves the name on the toolbar once the filtered list no longer
 * holds that row.
 */
export function scopeOptionsFor(
    filters: AuditLogFilters,
    entries: readonly AuditLogEntry[]
): AuditScopeOption[] {
    return AUDIT_SCOPE_KINDS.flatMap((kind) => {
        const id = filters[SCOPE_KEY[kind]];
        if (id === undefined) return [];
        for (const entry of entries) {
            const option = entry[kind]?.id === id ? optionFrom(entry, kind) : null;
            if (option !== null) return [option];
        }
        return [];
    });
}
